/**
 * Преобразование экранных координат мыши в координаты изображения.
 * Зависит от текущего вьюпорта (scale, translate) и позиции контейнера.
 */
import type { Point, Viewport } from '../domain/types';

export function eventToImagePoint(
  e: { clientX: number; clientY: number },
  container: HTMLElement,
  vp: Viewport,
): Point {
  const rect = container.getBoundingClientRect();
  const screenX = e.clientX - rect.left;
  const screenY = e.clientY - rect.top;
  return {
    x: (screenX - vp.tx) / vp.scale,
    y: (screenY - vp.ty) / vp.scale,
  };
}

/** Средняя точка двух точек (для центрирования маркеров и т.п.). */
export function midpoint(a: Point, b: Point): Point {
  return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
}
